import { Request } from 'components/Request';

// Moves the player's read cursor in a room with POST chat/read. Reads in a busy
// room come constantly, so they are batched: each room sends at most one read
// every READ_SYNC_DELAY_MS, carrying the newest message read, and pending reads
// go out at once when the tab is hidden.
export const READ_SYNC_DELAY_MS = 2000;

const pendingReads = new Map();
let flushTimer = null;
let listeningForHide = false;

const flushWhenHidden = () => {
	if(document.visibilityState === 'hidden') {
		flushRoomReads();
	}
};

export function flushRoomReads() {
	if(flushTimer !== null) {
		clearTimeout(flushTimer);
		flushTimer = null;
	}
	const reads = [...pendingReads];
	pendingReads.clear();
	reads.forEach(([chatRoomId, messageId]) => {
		Request.apiv1('chat/read', { chat_room_id: chatRoomId, message_id: messageId })
			.catch(() => null);
	});
}

export function scheduleRoomRead(chatRoomId, messageId) {
	const previous = pendingReads.get(chatRoomId);
	if(previous === undefined || messageId > previous) {
		pendingReads.set(chatRoomId, messageId);
	}
	if(!listeningForHide && typeof document !== 'undefined') {
		document.addEventListener('visibilitychange', flushWhenHidden);
		listeningForHide = true;
	}
	if(flushTimer === null) {
		flushTimer = setTimeout(flushRoomReads, READ_SYNC_DELAY_MS);
	}
}
